import React, { useState, useEffect } from 'react';
import { Logo } from '../common/Logo';

interface StravaConnectingScreenProps {
  progress: number;
}

const loadingMessages = [
  'Đang kết nối đến Strava...',
  'Đang xác thực tài khoản...',
  'Đang lấy lịch sử hoạt động...',
  'Đang xử lý dữ liệu...',
  'Sắp hoàn tất!'
];

export const StravaConnectingScreen: React.FC<StravaConnectingScreenProps> = ({ progress }) => {
  const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);

  useEffect(() => {
    const msgInterval = setInterval(() => {
      setLoadingMessageIndex(prev => (prev + 1) % loadingMessages.length);
    }, 2500);

    return () => clearInterval(msgInterval);
  }, []);

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center bg-slate-50 font-sans">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] bg-gradient-to-br from-blue-400 to-purple-500 rounded-full blur-3xl opacity-40 animate-float-slow mix-blend-multiply"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] bg-gradient-to-br from-pink-400 to-orange-400 rounded-full blur-3xl opacity-40 animate-float-medium mix-blend-multiply"></div>
        <div className="absolute top-[30%] left-[20%] w-[50%] h-[50%] bg-gradient-to-br from-teal-300 to-cyan-400 rounded-full blur-3xl opacity-30 animate-float-fast mix-blend-multiply"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center max-w-sm w-full p-8 px-4">
        <div className="mb-10 relative">
          <div className="absolute inset-0 bg-indigo-500/30 rounded-full blur-2xl animate-pulse"></div>
          <Logo className="w-28 h-28 text-indigo-600 relative z-10 drop-shadow-2xl animate-bounce-slow" />
        </div>

        <h2 className="text-3xl font-extrabold text-slate-800 mb-2 text-center animate-fade-in tracking-tight">
          TechCoop Sports
        </h2>

        <div className="h-16 flex items-center justify-center w-full mb-8">
          <p
            key={loadingMessageIndex}
            className="text-slate-600 font-medium text-lg animate-fade-in text-center"
          >
            {loadingMessages[loadingMessageIndex]}
          </p>
        </div>

        {/* Progress Bar */}
        <div className="w-full max-w-xs h-4 bg-slate-200/80 backdrop-blur-sm rounded-full overflow-hidden shadow-inner border border-white/50 relative">
          <div
            className="h-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 animate-stripe transition-all duration-300 ease-out rounded-full shadow-lg shadow-indigo-500/20"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <p className="text-right w-full max-w-xs text-xs text-indigo-500 font-bold mt-2 pr-1">
          {Math.round(progress)}%
        </p>

        <p className="text-slate-400 text-sm mt-6 text-center max-w-xs">
          Quá trình này có thể mất vài phút cho lần đồng bộ đầu tiên. Vui lòng không tắt trình duyệt.
        </p>
      </div>
    </div>
  );
};
